import { Link } from "react-router-dom";
import { C, GlassCard, Button } from "@coremonit/design-system";
import { Compass, ArrowLeft } from "lucide-react";

export function NotFoundPage() {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 40 }}>
      <GlassCard style={{ padding: 40, textAlign: "center", maxWidth: 460 }}>
        <div style={{ width: 56, height: 56, borderRadius: 18, background: C.blueDim, border: `1px solid ${C.borderBright}`, color: C.blue, display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 12 }}>
          <Compass size={22} />
        </div>
        <h2 style={{ color: C.text, fontSize: 18, fontWeight: 700, margin: "0 0 6px" }}>Page not found</h2>
        <p style={{ color: C.textMuted, fontSize: 12, marginBottom: 20 }}>The route you tried to open doesn't exist. Head back to the Overview.</p>
        <Link to="/" style={{ textDecoration: "none" }}>
          <Button variant="glow" icon={<ArrowLeft size={12} />}>Back to overview</Button>
        </Link>
      </GlassCard>
    </div>
  );
}
